import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Grid, TextField, Button, Typography } from '@material-ui/core';
import PaddedGrid from './PaddedGrid';
import APIService from '../services/APIService';
import { withTranslation } from 'react-i18next';

class ReportStarter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reporter: props.report ? props.report.reporter : '',
            redirect: false
        };
    }

    clickHandler() {
        const { report } = this.props;
        const { reporter } = this.state;

        APIService.updateReport(report.restaurant.id, report.id, {
            reporter
        }).then(() => this.setState({redirect: true}));
    }

    componentWillReceiveProps(props) {
        this.setState({
            reporter: props.report ? props.report.reporter : '',
        });
    }

    render() {
        const { report } = this.props;

        if (this.state.redirect) {
            return <Redirect to={`/restaurants/${report.restaurant.id}/reports/${report.id}`}/>;
        }

        if (!report) {
            return (
                <PaddedGrid well>
                    <Grid item xs={12}>
                        <Typography variant="title">{this.props.t('Ei avoimia kirjauksia')}</Typography>
                    </Grid>
                </PaddedGrid>
            );
        }

        return (
            <PaddedGrid well>
                <Grid item xs={12}>
                    <TextField
                        disabled
                        fullWidth
                        label={this.props.t('Toimipaikka')}
                        value={report.restaurant.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={this.props.t('Kirjaaja')}
                        value={this.state.reporter}
                        onChange={(event) => this.setState({reporter: event.target.value})}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button variant="raised"
                        color="primary"
                        onClick={() => this.clickHandler()}
                    >
                        {report.status == 1 ? this.props.t('Aloita kirjaus') : this.props.t('Jatka kirjaamista')}
                    </Button>
                </Grid>
            </PaddedGrid>
        );
    }
}

ReportStarter.propTypes = {
    report: PropTypes.object.isRequired
};

export default withTranslation()(ReportStarter);



// WEBPACK FOOTER //
// ./resources/assets/js/components/ReportStarter.js